@if (!!fileControl) {
  <div
    class="file-input-container"
    [class.disabled]="disabled"
    [ngbTooltip]="disabled ? MAX_STUDENTS_TOOLTIP : ''">
    <!-- Show when file is not yet selected -->
    <label [hidden]="Boolean(fileControl.value)"
      [for]="uniqueId"
      class="import-drop-zone"
      [class.drag-and-drop-enabled]="dragAndDropEnabled">
      <div class="import-drop-zone-icon" [class.disabled]="disabled">
        <zbp-icon [iconName]="zbpIconNames.upload"
          primaryColor="white">
        </zbp-icon>
      </div>
      <div class="import-drop-zone-prompt">
        @if (dragAndDropEnabled) {
          <span>Drag and Drop or&nbsp;</span>
        }
        <a class="text-link">Choose File</a>
      </div>
      @if (supportedFormats.length > 0) {
        <div
          class="import-drop-zone-subtext">
          Supported formats:
          <ul class="format-list">
            @for (format of supportedFormats; track $index) {
              <li>
                {{ format.display }}
              </li>
            }
          </ul>
        </div>
      }
      <input [id]="uniqueId"
        type="file"
        [formControl]="fileNameControl"
        [accept]="getSupportedExtensions()"
        (change)="onFileInputChange($event)"
        />
    </label>
    <!-- Show when file is selected -->
    @if (!uploadInProgress
      && !uploadSuccess
      && Boolean(fileControl.value)) {
      <div
        class="import-pre-upload">
        <div class="file-name-display-chip">
          <zbp-icon [iconName]="zbpIconNames.file"
            class="file-icon">
          </zbp-icon>
          <span>{{ fileControl?.value?.name }}</span>
          <zbp-button-component
            [iconName]="zbpIconNames.x_cross"
            (clickHandler)="onFileXButtonClick()"
            theme="icon">
          </zbp-button-component>
        </div>
        @if (!hasError()) {
          <zbp-button-component
            [iconName]="zbpIconNames.upload"
            (clickHandler)="onUploadButtonClick()"
            label="Upload"
            theme="secondary"
            />
        } @else {
          <zbp-button-component
            class="remove-button"
            [iconName]="zbpIconNames.x_cross"
            (clickHandler)="onFileXButtonClick()"
            label="Remove"
            theme="primary">
          </zbp-button-component>
        }
      </div>
    }
    <!-- Show when upload is in progress -->
    @if (uploadInProgress) {
      <div
        class="upload-in-progress-container">
        <zbp-preloader [responsive]="false">
        </zbp-preloader>
      </div>
    }
    <!-- Show when selected file has errors -->
    @if (!uploadInProgress
      && !uploadSuccess
      && Boolean(fileControl.value)
      && hasError()) {
      <div
        class="import-message import-error-message">
        <div class="import-message-display">
          <div class="import-message-display-header">
            <zbp-icon [iconName]="zbpIconNames.info_circle">
            </zbp-icon>
            <span>The Following Validation Errors Occurred</span>
          </div>
          <div class="import-message-body">
            <ul>
              @for (error of getAllErrors(); track $index) {
                <li>
                  {{ error }}
                </li>
              }
            </ul>
            <span class="import-message-display-footer">
              Please fix these errors and upload the file again.
            </span>
          </div>
        </div>
      </div>
    }
    <!-- Show when upload is successful -->
    @if (!uploadInProgress && uploadSuccess) {
      <div>
        <div class="import-success-container">
          <zbp-icon [iconName]="zbpIconNames.check_circle">
          </zbp-icon>
          <span>
            File was uploaded successfully
          </span>
        </div>
        <div class="import-message import-success-message">
          <div class="import-message-display">
            <div class="import-message-display-header">
              <zbp-icon [iconName]="zbpIconNames.info_circle">
              </zbp-icon>
              <span>Import Successful</span>
            </div>
            <div class="import-message-body">
              <ul>
                @for (item of successInstructions; track $index) {
                  <li>{{item}}</li>
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div>File Control is Missing!</div>
}

